import * as React from 'react';
import { useReducer } from 'react';

import { SlMenuItem } from '@shoelace-style/shoelace/dist/react';
import { TeamRole } from '@showbie-socrative/socrative-utils';

import { roleNamesAndDescriptions } from '~teacher/components/Account/TeamMembers/TeamMembersTable/RoleActionMenu/roleNamesAndDescriptions';

interface RoleActionMenuItemProps
  extends Pick<React.ComponentProps<typeof SlMenuItem>, 'onClick'> {
  menuItemTeamRole: TeamRole;
  targetMemberRole: TeamRole;
}

export function RoleActionMenuItem({
  targetMemberRole,
  onClick,
  menuItemTeamRole,
}: RoleActionMenuItemProps) {
  const { title, description } = roleNamesAndDescriptions[menuItemTeamRole];

  // the `checked` is the `initial state` of the check. Which means
  // that simply changing the `checked` prop does not update the component
  // This uses forceUpdate to ensure that the `checked` property is kept
  // in sync with the actual value.
  const checked = targetMemberRole === menuItemTeamRole;
  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  return (
    <SlMenuItem
      className="change-role-menu-item"
      type="checkbox"
      checked={checked}
      onClick={(evt) => {
        // `checked` on an `SLMenuItem` only sets the initial value.
        // Clicking on it will change the `checked` value, which is not desired.
        if (!checked) {
          onClick(evt);
        }
        forceUpdate();
      }}
    >
      <div className="font-sans leading-8 text-base font-400 text-blue-900 overflow-ellipsis">
        {title}
      </div>
      <div className="font-sans leading-6 text-xs text-grey-900 whitespace-normal">
        {description}
      </div>
    </SlMenuItem>
  );
}
